import "./App.css";
import React, { useState, useEffect, useRef } from "react";
import PythonIDE from "./components/ide/python-ide";
import ArduinoIDE from "./components/ide/arduino-ide";
import HtmlCssIDE from "./components/ide/html-css-ide";
import GeekyBirdGame from "./components/games/geeky-bird-game";
import GeekyBirdGameProgrammable from "./components/games/geeky-bird-game-programmable";
import CodeCompatGame from "./components/games/code-compat";
import DanceMat from "./components/games/dance-mat-typing";
import TuxPaint from "./components/painting/tux-paint";
import AIForOceans from "./components/project/ai-for-oceans";
import TypingNinja from "./components/games/typing-ninja";
import WebTypist from "./components/games/web-typist";
import MitAppInventor from "./components/ide/mit-app";
import MitAppInventor2 from "./components/ide/mit-app-2";
import Home from "./components/home";
import Projects from "./components/projects";
import EvaluateProjects from "./components/evaluate-projects";
import ManageCsLabMenu from "./components/manage-cs-lab-menu";
import LabQuestionView from "./components/labAssignments/lab-question-view";
import AssignmentReport from "./components/labAssignments/assignment-report";
import ModalComponent from "./components/labAssignments/assignment-details-modal";
import SourceCodeModal from "./components/labAssignments/view-source-code-modal";
import Portfolio from "./components/portfolio";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { lms_v2_api, global_var } from "./services/cs-lab-config";
import { Spin, Result } from "antd";
import SqlIde from "./components/ide/sqlpad-ide";
import VisualCodingIde from "./components/ide/vc3-ide";
import FlowCircuitIde from "./components/ide/flow-circuit-ide";
import ScratchJrIde from "./components/ide/scratchJr-ide"
import MakeCodeIde from "./components/ide/makecode-ide";
import GoogleAppIde from "./components/ide/google-app-ide";
import AssignmentList from "./components/labAssignments/assignmentList";
import ReactGA from "react-ga4";
import AIAutoBulkEvaluate from "./components/labAssignments/ai-auto-bulk-evaluate";
import ManageAiFeatures from "./components/manage-ai-features";
import RouteWatcher from "./services/route-watcher-service";

function App() {
  let authToken = new URLSearchParams(window.location.search).get("token");
  let platform = new URLSearchParams(window.location.search).get("platform");

  global_var.platform = platform || 'web';

  const [authorized, setAuthorized] = useState(false);
  const [showSpinner, setShowSpinner] = useState(
    !!(authToken || sessionStorage.getItem('token'))
  );

  function authenticateUser(authToken) {

    setShowSpinner(true);

    lms_v2_api
      .post("/lmsAuth/lmsToken/", {
        authToken,
      })
      .then((res) => {

        res = res.data;

        if (res.statusCode === 200) {

          sessionStorage.setItem('token', authToken);
          global_var.user_login_id = res.userDetails.userLoginId;
          global_var.user_name = res.userDetails.Name;
          global_var.username = res.userDetails.username;
          global_var.role_id = res.userDetails.roleId;
          global_var.role_name = res.userDetails.roleName;
          global_var.company_id = res.userDetails.companyId;
          if (res.userDetails.parentCompanyId) {
            global_var.parent_company_id = res.userDetails.parentCompanyId;
          }
          global_var.roleMappingId = res.userDetails.lastLoggedRoleMapping;
          lms_v2_api
            .get("/company/" + res.userDetails.companyId)
            .then((companyRes) => {

              setShowSpinner(false);

              companyRes = companyRes.data;

              if (companyRes.statusCode === 200) {
                global_var.company_name =
                  companyRes.companyDetails.company_obj.companyName;

                if (
                  companyRes.companyDetails.companySettings.currentAcademicYear
                ) {
                  global_var.academicYearName =
                    companyRes.companyDetails.companySettings.currentAcademicYearName;
                }
                if (
                  companyRes.companyDetails.companySettings.currentAcademicYear
                ) {
                  global_var.academicYearId =
                    companyRes.companyDetails.companySettings.currentAcademicYear;
                }
                if (companyRes.companyDetails.companySettings.needClasses) {
                  global_var.needClass =
                    companyRes.companyDetails.companySettings.needClasses;
                }
                if (companyRes.companyDetails.companySettings.needDivisions) {
                  global_var.needDivision =
                    companyRes.companyDetails.companySettings.needDivisions;
                }
                if (companyRes.companyDetails.companySettings.streamAvailable) {
                  global_var.streamAvailable =
                    companyRes.companyDetails.companySettings.streamAvailable;
                }
                if (
                  companyRes.companyDetails.company_obj.appSettings &&
                  companyRes.companyDetails.company_obj.appSettings.logo
                ) {
                  global_var.companyLogo =
                    companyRes.companyDetails.company_obj.appSettings.logo;
                }

                if (companyRes.companyDetails.companySettings.enabledAiFeatures) {
                  global_var.assignedAiFeatures = companyRes.companyDetails.companySettings.enabledAiFeatures;
                }

                ReactGA.set({ userId: global_var.user_login_id });

                // const script = document.createElement("script");
                // script.id = "zfEmbed";
                // script.innerHTML = `
                //   window._zfQueue = window._zfQueue || [];
                //   function _zf(){_zfQueue.push(arguments);}
                //   (function() {
                //     ZonkaFeedback = function(en, fb) {
                //       document.body.addEventListener(en, fb, false);
                //     };
                //     var sc, w, d = document, ce = d.createElement, gi = d.getElementById, gt = d.getElementsByTagName, id = "zfEmbedScript";
                //     if (!gi.call(d, id)) {
                //       sc = ce.call(d, "script");
                //       sc.async = true;
                //       sc.id = id;
                //       sc.src = "https://us-js.zonka.co/6501840ea6e21a0008af9d09";
                //       w = gt.call(d, "script")[0];
                //       w.parentNode.insertBefore(sc, w);
                //     }
                //   })();
                //   _zf('variables', {
                //     contact_name: "${global_var.user_name}",
                //     contact_uniqueid: "${global_var.user_login_id}",
                //     contact_company_name: "${global_var.company_name}",
                //     user_role: "${global_var.role_name}"
                //   });
                // `;

                setAuthorized(true);
                lms_v2_api.get("/company/" + global_var.company_id + "/companyConf").then((res) => {
                  if (res.data.statusCode === 200 && res.data.uiConf) {

                    if (res.data.uiConf.teacherAccessRestricted && global_var.role_id === global_var.TEACHER_ROLE_ID) {
                      global_var.teacherAccessRestricted = true;
                    }
                  }
                });
                // document.head.appendChild(script);
              } else {
                setShowSpinner(false);
                setAuthorized(false);
              }
            });
        } else {
          setShowSpinner(false);
          setAuthorized(false);
        }
      });

  }

  const authTokenRef = useRef(authToken); // Store authToken in a ref

  useEffect(() => {
    if (authTokenRef.current) {
      authenticateUser(authTokenRef.current);
    } else {
      // const storedToken = localStorage.getItem("token");
      const storedToken = sessionStorage.getItem('token');

      if (storedToken) {
        authTokenRef.current = storedToken; // Update the ref with the stored token
        authenticateUser(authTokenRef.current);
      }
    }
  }, []);

  return (
    <div className="container-fluid">
      {showSpinner ? (
        <div
          style={{
            textAlign: "center",
            marginTop: "10rem",
          }}
        >
          <Spin />
        </div>
      ) : (
        false
      )}

      {!authToken && !authorized && !showSpinner ? (
        <div style={{ textAlign: "center", marginTop: 25 }}>
          <Result
            status="403"
            title="unauthorized"
            subTitle="You appear to not be logged into CS Cloud Lab because we were unable to find an auth token."
          />
        </div>
      ) : (
        false
      )}

      {authToken && !authorized && !showSpinner ? (
        <div style={{ textAlign: "center", marginTop: 25 }}>
          <Result
            status="403"
            title="unauthorized"
            subTitle="It seems like your token is expired or invalid. Please login again."
          />
        </div>
      ) : (
        false
      )}

      {authorized ? (
        <>
          <BrowserRouter>
            <RouteWatcher>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/projects/:projectStack?" element={<Projects />} />
                <Route path="/pythonide/:ideProjectId?" element={<PythonIDE />} />
                <Route path="/arduinoide/:ideProjectId?" element={<ArduinoIDE />} />
                <Route
                  path="/htmlcsside/:ideProjectId?"
                  element={<HtmlCssIDE />}
                />
                <Route path="/codecompat/" element={<CodeCompatGame />} />
                <Route path="/geekybird/" element={<GeekyBirdGame />} />
                <Route
                  path="/geekybirdpr/"
                  element={<GeekyBirdGameProgrammable />}
                />
                <Route path="/dancemat/" element={<DanceMat />} />
                <Route path="/tuxpaint/:ideProjectId?" element={<TuxPaint />} />
                <Route path="/ai-for-oceans/" element={<AIForOceans />} />
                <Route path="/typingninja/" element={<TypingNinja />} />
                <Route path="/webtypist/" element={<WebTypist />} />
                <Route path="/evaluateprojects/:resourceId?/:labQuestionMappingId?" element={<EvaluateProjects />} />
                <Route path="/labquestionview/" element={<LabQuestionView />} />
                <Route path="/assignmentreport/:resourceId?/:labQuestionMappingId?/" element={<AssignmentReport />} />
                <Route path="/assignmentdetailmodal/" element={<ModalComponent />} />
                <Route path="/sourcecodemodal/" element={<SourceCodeModal />} />
                <Route path="/portfolio/" element={<Portfolio />} />
                <Route path="/sqlide/:sqlQueryId?" element={<SqlIde />} />
                <Route path="/vc3/:ideProjectId?" element={<VisualCodingIde />} />
                <Route path="/flowcircuit/:ideProjectId?" element={<FlowCircuitIde />} />
                <Route path="/scratchjr/:ideProjectId?" element={<ScratchJrIde />} />
                <Route path="/makecode/:ideProjectId?" element={<MakeCodeIde />} />
                <Route path="/gapp/:projectStack/:ideProjectId?" element={<GoogleAppIde />} />
                <Route path="/mit/" element={<MitAppInventor />} />
                <Route path="/mit2/" element={<MitAppInventor2 />} />
                <Route path="/assignments/" element={<AssignmentList />} />
                <Route path="/managecslabmenu/" element={<ManageCsLabMenu />} />
                <Route path="/manageaifeatures/" element={<ManageAiFeatures />} />
                <Route path="/aiautobulkevaluate/:resourceId?/:labQuestionMappingId?/" element={<AIAutoBulkEvaluate />} />
              </Routes>
            </RouteWatcher>
          </BrowserRouter>

          <Outlet />
        </>
      ) : (
        false
      )}
    </div>
  );
}

export default App;
